import { getRailsEnv } from "./railsEnv.mjs";
//#region src/segment.ts
var SEGMENT_METHODS = [
	"trackSubmit",
	"trackClick",
	"trackLink",
	"trackForm",
	"pageview",
	"identify",
	"reset",
	"group",
	"track",
	"ready",
	"alias",
	"debug",
	"page",
	"once",
	"off",
	"on",
	"addSourceMiddleware",
	"addIntegrationMiddleware",
	"setAnonymousId",
	"addDestinationMiddleware"
];
var RESET_PASSWORD_TOKEN_REGEX = /reset_password_token=[a-zA-Z0-9_\-\.]+?(?=&|$)/;
var ACCESS_TOKEN_REGEX = /access_token=[a-zA-Z0-9_\-\.]+?(?=&|$)/;
if (typeof window !== "undefined") {
	const segment = [];
	window.analytics = window.analytics || segment;
	segment.factory = function(method) {
		return function() {
			var args = Array.prototype.slice.call(arguments);
			args.unshift(method);
			segment.push(args);
			return segment;
		};
	};
	for (var i = 0; i < SEGMENT_METHODS.length; i++) {
		var key = SEGMENT_METHODS[i];
		segment[key] = segment.factory(key);
	}
	segment.addSourceMiddleware(({ payload, next }) => {
		if (navigator !== void 0 && navigator.userAgent && navigator.userAgent.includes !== void 0) {
			if (navigator.userAgent.includes("HeadlessChrome")) return null;
		}
		next(payload);
	});
	segment.SNIPPET_VERSION = "4.15.2";
	segment._loadOptions = { user: { localStorageFallbackDisabled: true } };
	segment.page({
		url: window.location.href.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED"),
		search: window.location.search.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED")
	});
}
var segmentWrapper = {};
SEGMENT_METHODS.forEach((methodName) => {
	segmentWrapper[methodName] = function() {
		window.analytics[methodName].apply(window.analytics, arguments);
	};
});
var loadSegment = (key) => {
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.async = true;
	if (key) script.src = ("https:" === document.location.protocol ? "https://" : "http://") + "trkcdn.opendoor.com/analytics.js/v1/" + key + "/analytics.min.js";
	else script.src = ("https:" === document.location.protocol ? "https://" : "http://") + (getRailsEnv() === "production" ? "www.opendoor.com" : "demo.simplersell.com") + "/_scripts/sgm.min.js";
	var first = document.getElementsByTagName("script")[0];
	first.parentNode.insertBefore(script, first);
};
//#endregion
export { segmentWrapper as default, loadSegment };

//# sourceMappingURL=segment.mjs.map